import { render, staticRenderFns } from "./category-detail-v2.vue?vue&type=template&id=ea7d68e8&scoped=true"
import script from "./category-detail-v2.vue?vue&type=script&lang=js"
export * from "./category-detail-v2.vue?vue&type=script&lang=js"
import style0 from "./category-detail-v2.vue?vue&type=style&index=0&id=ea7d68e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7d68e8",
  null
  
)

export default component.exports